import ListingInProtfolioEmptyState from './ListingInProtfolioEmptyState.component';

export default ListingInProtfolioEmptyState;
